import { Model } from "@datx/core";
import { jsonapi } from "@datx/jsonapi";

export default class Property extends jsonapi(Model) {
  static type = "property";
}
